<rsswa-section1 [rsswa]="originalBody" [disabled]="true" [status]="status">
</rsswa-section1>
<form-history-signatures
  [update]="update"
  *ngIf="update"
></form-history-signatures>
